module.exports = __webpack_public_path__ + "static/media/tree2ocean.cf9a1c0d.jpg";